import React from 'react';
export var Region = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "max-w-xl mr-auto box-border m-0" }, children));
};
